<p-drawer
  [visible]="true"
  (onHide)="onCancel()"
  position="right"
  styleClass="picker-panel"
>
  <ng-template #header>
    <div class="ngkit-flex-container-column">
      <span class="picker-panel__subtitle">Manage</span>
      <span class="picker-panel__title">{{ view().title }}</span>
    </div>
  </ng-template>

  <ng-template #content>
    <div class="picker-panel__content">
      <div class="picker-panel__header">
        @if (view(); as modeView) {
          <div
            class="ngkit-flex-container-column ngkit-gap--xxxxxs"
            [class.picker-panel__owner-type]="isOwnersMode()"
            [class.picker-panel__member-type]="isMembersMode()"
          >
            <span id="typeFilterLabel" class="picker-panel__label ngkit-form-field__label">
              {{ modeView.typeFilterLabel }}
            </span>
            <p-selectButton
              class="ngkit-selecttag"
              [attr.data-testid]="modeView.typeFilterTestId"
              [options]="modeView.typeFilterOptions"
              [allowEmpty]="false"
              optionLabel="label"
              optionValue="value"
              ariaLabelledBy="typeFilterLabel"
              [ngModel]="typeFilterValue()"
              (ngModelChange)="onTypeFilterChange($event)"
            />
          </div>

          <div class="picker-panel__filter ngkit-flex-container-column ngkit-gap--xxxxxs">
            <span class="picker-panel__label ngkit-form-field__label">Name</span>
            <ngkit-search
              class="ngkit-width-full"
              [placeholder]="modeView.searchPlaceholder"
              [prepopulatedSearchQuery]="filterText()"
              (searchUpdated)="onSearch($event)"
              (searchCleared)="onClearSearch()"
            />
          </div>
        }
      </div>

      <div class="picker-panel__body">
        @if (filteredItems().length > 0) {
          <ul
            class="picker-panel__list"
            role="listbox"
            aria-multiselectable="true"
            [attr.aria-label]="view().title"
          >
            @for (item of filteredItems(); track item.id) {
              <li class="picker-panel__item ngkit-flex-container-row" role="presentation">
                <button
                  type="button"
                  role="option"
                  class="picker-panel__item-button"
                  [class.is-active]="item.selected"
                  [attr.aria-selected]="item.selected"
                  [attr.aria-label]="item.label"
                  (click)="onToggle(item, !item.selected)"
                >
                  <p-checkbox
                    class="picker-panel__item-checkbox"
                    [binary]="true"
                    [ngModel]="item.selected"
                    (onChange)="onToggle(item, $event.checked)"
                    (click)="$event.stopPropagation()"
                  ></p-checkbox>
      
                  @if (itemIcons().get(item.id); as iconName) {
                    <fga-icon
                      class="picker-panel__item-icon"
                      [name]="iconName"
                    />
                  }

                  <div class="ngkit-flex-container-column min-width-0">
                    <span class="picker-panel__item-title text-truncate min-width-0" [fgaEllipsisTitle]="item.label">
                      {{ item.label }}
                    </span>
                    @if (item.email) {
                      <span
                        class="picker-panel__item-subtitle text-truncate min-width-0"
                        [fgaEllipsisTitle]="item.email"
                      >
                        {{ item.email }}
                      </span>
                    }
                  </div>
                </button>
              </li>
            }
          </ul>
        } @else {
          <div class="picker-panel__empty" role="status">
            <i class="picker-panel__empty-icon ds-ngkit ds-ngkit-users" aria-hidden="true"></i>
            <p class="picker-panel__empty-message">No {{ view().entityLabel }} found</p>
          </div>
        }
      </div>

      <div class="picker-panel__footer ngkit-flex-container-row ngkit-spacing-y-3 ngkit-gap--xxxxs">
        <p-button
          [label]="hasChanges() ? `Save (${changesCount()})` : 'Save'"
          styleClass="ngkit-button ngkit-button-lg"
          severity="primary"
          (onClick)="onSave()"
        ></p-button>

        <p-button
          label="Cancel"
          styleClass="ngkit-button ngkit-button-lg"
          severity="primary"
          variant="outlined"
          (onClick)="onCancel()"
        ></p-button>
      </div>
    </div>
  </ng-template>
</p-drawer>
